var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Image from '../Image/Image';
import Badges from './Badges';
const ProdImage = (_a) => {
    var { image, sizes = [1 / 4, 1 / 3, 1 / 2, 1 / 2], badges, aspect = '1:1' } = _a, rest = __rest(_a, ["image", "sizes", "badges", "aspect"]);
    const imageOrSizes = image && (image.url || image.sizes);
    return (React.createElement(Image, Object.assign({ src: imageOrSizes, sizes: sizes, aspect: aspect, title: image && image.title, alt: image && image.alt }, rest),
        React.createElement(Badges, { badges: badges })));
};
export default ProdImage;
//# sourceMappingURL=ProductImage.js.map